module.exports = __webpack_public_path__ + "11b18f78efabb0489ba6d5c98c57326e.svg";